import { DEVELOPERS_SEGMENT_PAGE } from "@/data/marketing/segmentPages";
import SegmentLandingPage from "./SegmentLandingPage";

const HelpGenieForDevelopersPage = () => {
  return <SegmentLandingPage content={DEVELOPERS_SEGMENT_PAGE} />;
};

export default HelpGenieForDevelopersPage;
